/* eslint-disable */
import React, { useEffect, useState, useMemo } from "react";
import { Link, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Material UI table
import { MaterialReactTable } from "material-react-table";
//Material UI components for rendring menu and others
import { MenuItem } from "@mui/material";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import { getData, postData, putData } from "utils/Gateway";

import { assetImages } from "constants";

import AddLabelModal from "components/Common/Modal/AddLabelModal";
import CourseListFilterPopup from "../Popup/CourseListFilterPopup";
import CourseListHeader from "../Header/CourseListHeader";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import DeleteWarningModal from "components/Common/Modal/DeleteWarningModal";
import { createContactChatHandler } from "helper/AppUserHelper/AppUserHelper";
import AddFollowerModal from "components/Common/Modal/AddFollowerModal";
import { replaceListByIds } from "helper/Common/CommonHelper";
import { removeTagHandler } from "helper/TagHelper/TagHelper";

const CourseListBody = () => {
  const history = useHistory();

  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const moduleAccess = localStorage.getItem("moduleaccess");

  const { t, i18n } = useTranslation(); //for translation

  const [isLoading, setIsLoading] = useState(false);
  const [courseList, setCourseList] = useState([]);

  //optionally, you can manage the row selection state yourself
  const [rowSelection, setRowSelection] = useState({});
  const [selectedCourseIds, setSelectedCourseIds] = useState([]);
  const [selectedCourseId, setSelectedCourseId] = useState(null);
  const [selectedTagId, setSelectedTagId] = useState(null);

  const [reloadData, setReloadData] = useState(false);

  const [filterStartDate, setFilterStartDate] = useState("");
  const [filterEndDate, setFilterEndDate] = useState("");
  const [filterTitle, setFilterTitle] = useState("");
  const [filterCode, setFilterCode] = useState("");
  const [filterLanguage, setFilterLanguage] = useState("");
  const [filterTags, setFilterTags] = useState([]);

  // json filter query
  const [jsonFilterQuery, setJsonFilterQuery] = useState([]);
  // const [reloadData, setReloadData] = useState(false);
  const [isFilterReset, setIsFilterReset] = useState(false);

  //* alert requirements
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  //get course list
  const getAllCourses = async () => {
    setRowSelection({});
    setSelectedCourseIds([]);

    try {
      setIsLoading(true);

      let requestURL =
        url.API_BASE_URL +
        url.API_GET_ALL_COURSE_RECORDS +
        `?token=${token}&modulefrom=backend`;

      if (filterStartDate !== "" && filterEndDate !== "") {
        requestURL += `&filterstartdate=${filterStartDate}&filterenddate=${filterEndDate}`;
      }

      if (filterTitle != "") {
        requestURL += `&filtertitle=${filterTitle}`;
      }

      if (filterCode != "") {
        requestURL += `&filtercode=${filterCode}`;
      }

      if (filterLanguage != "") {
        requestURL += `&filterlanguage=${filterLanguage}`;
      }

      if (filterTags != "") {
        requestURL += `&filtertags=${filterTags}`;
      }

      console.log("Course url", requestURL);

      const response = await getData(requestURL);

      console.log(response);

      setIsLoading(false);

      if (response.status) {
        setMessageType("success");
        setCourseList(response.data);
      } else {
        setAlertMessage("error");
      }
      setAlertMessage(response.message);
    } catch (error) {
      setMessageType("error");
      setAlertMessage(error.message);
    }
    setShowAlert(true);
  };

  const getFilteredCourse = async () => {
    try {
      setIsLoading(true);

      let requestURL =
        url.API_BASE_URL + url.API_GET_FILTERED_COURSE + `?token=${token}`;

      console.log("requestURL in getFilteredCourse------>", requestURL);

      console.log("Original jsonFilterQuery:", jsonFilterQuery);

      // Sanitize the jsonFilterQuery
      const sanitizedQuery = jsonFilterQuery.map((filter) => {
        if (
          (filter.operator === "includes" || filter.operator === "excludes") &&
          Array.isArray(filter.value)
        ) {
          return {
            ...filter,
            value: filter.value.map((item) => item.value).join(","), // Extract and join values as a comma-separated string
          };
        }
        return filter;
      });

      console.log("Sanitized jsonFilterQuery:", sanitizedQuery);

      const filterData = {
        filters: sanitizedQuery,
      };

      console.log("filter data------->", filterData);

      const response = await postData(requestURL, filterData);

      console.log("response in course list------>", response);

      setIsLoading(false);

      if (response.status) {
        setMessageType("success");
        setCourseList(response.data);
      } else {
        setAlertMessage("error");
      }
      setAlertMessage(response.message);
    } catch (error) {
      setMessageType("error");
      setAlertMessage(error.message);
    }
    setShowAlert(true);
  };

  //function for delete course
  const deleteMassiveCourseHandler = async () => {
    if (selectedCourseIds.length > 0) {
      const courseListToBeDelete = courseList.filter((item) =>
        selectedCourseIds.includes(item._id)
      );

      try {
        let courseData = {
          courselist: courseListToBeDelete,
        };

        let requestURL =
          url.API_BASE_URL + url.API_DELETE_MASSIVE_COURSE + `?token=${token}`;

        const response = await putData(requestURL, courseData);

        console.log("response in deleteMassiveCourseHandler", response);

        if (response.status) {
          setMessageType("success");
          setTimeout(() => {
            setCourseList((prevList) =>
              prevList.filter((item) => !selectedCourseIds.includes(item._id))
            );
          }, 1500);
        } else {
          setMessageType("error");
        }

        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }

      setShowAlert(true);
    } else {
      setMessageType("error");
      setAlertMessage("Please select atleast one course");
      setShowAlert(true);
    }
  };

  //function for change rank
  const rankInputChangeHandler = (row, value) => {
    const updatedCourseList = [...courseList];

    const rowIndex = updatedCourseList.findIndex(
      (course) => course._id === row.original._id
    );

    if (rowIndex !== -1) {
      updatedCourseList[rowIndex].rank = value;
      setCourseList(updatedCourseList);
    }
  };

  //function for update rank
  const updateBulkCourseHandler = async (e) => {
    if (selectedCourseIds.length > 0) {
      try {
        const courseListToBeUpdate = courseList.filter((item) =>
          selectedCourseIds.includes(item._id)
        );

        let courseData = {
          courselist: courseListToBeUpdate,
        };

        let requestURL =
          url.API_BASE_URL + url.API_UPDATE_MASSIVE_COURSE + `?token=${token}`;

        const response = await putData(requestURL, courseData);

        console.log(response);

        if (response.status) {
          setMessageType("success");

          setTimeout(() => {
            setSelectedCourseIds([]);
            setRowSelection({});
          }, 1500);
        } else {
          setMessageType("error");
        }

        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }
    } else {
      setMessageType("error");
      setAlertMessage("Please select atleast one course");
    }
    setShowAlert(true);
  };

  //function for remove tag from course
  const removeTagFromCourse = async (tagIds, componentId) => {
    try {
      const componentUrl = url.API_ADD_REMOVE_TAG_COURSE; // Assuming a similar API endpoint for events
      const data = await removeTagHandler(tagIds, componentId, componentUrl);

      if (data) {
        afterModalActionClose(data);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setTimeout(() => {
        setSelectedTagId(null);
        setSelectedCourseId(null);
      }, 1000);
    }
  };

  //function for after modal close
  const afterModalActionClose = (data = []) => {
    setTimeout(() => {
      setCourseList((prev) => replaceListByIds(prev, data));
    }, 1000);
  };

  //reset filter
  const resetFilter = () => {
    setJsonFilterQuery([]);
    setIsFilterReset(true);
    setReloadData(true);
  };

  useEffect(() => {
    if (reloadData) {
      getAllCourses();
      setReloadData(false);
    }
  }, [reloadData]);

  useEffect(() => {
    if (jsonFilterQuery.length > 0) {
      getFilteredCourse();
    }
  }, [jsonFilterQuery]);

  useEffect(() => {
    getAllCourses();
  }, []);

  /** Material React Table Column and States */
  const columns = useMemo(
    () => [
      {
        accessorKey: "title",
        header: t("Course"),
        size: 250,
      },
      {
        accessorKey: "tagstring",
        header: t("Label"),
        Cell: ({ row }) => (
          <div className="label-wrapper py-1">
            <div className="d-flex gap-2">
              <div
                className={
                  row.original.tags.length > 0
                    ? "label-container flex-grow-1"
                    : "d-none"
                }
              >
                <ul
                  className="d-flex flex-wrap gap-2 m-0 p-0"
                  style={{ listStyle: "none" }}
                >
                  {row.original.tags.map((tag, index) => (
                    <li key={index} className="d-inline-flex">
                      <div className="badge d-flex align-items-center px-3 py-2 border-0 gradient-light text-black rounded-pill">
                        <span className="badge-text fs-xs fw-medium me-1">
                          {tag.title}
                        </span>
                        <Link
                          to="#"
                          className={`${
                            tag.moderator.toString() ===
                              userInfo._id.toString() ||
                            userInfo.role.slug === "ADMIN" ||
                            userInfo.role.slug === "SUPER_ADMIN"
                              ? "d-block"
                              : "d-none"
                          }`}
                          onClick={() => {
                            setSelectedCourseId(row.original._id);
                            setSelectedTagId(tag._id);
                            removeTagFromCourse([tag._id], row.original._id);
                          }}
                        >
                          {selectedTagId &&
                          selectedTagId === tag._id &&
                          selectedCourseId &&
                          selectedCourseId === row.original._id ? (
                            <div
                              className="spinner-border spinner-border-sm text-primary ms-1"
                              role="status"
                              style={{ height: "12px", width: "12px" }}
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          ) : (
                            <span
                              className="d-block text-primary material-symbols-outlined icon-sm ms-1"
                              style={{ cursor: "pointer" }}
                            >
                              cancel
                            </span>
                          )}
                        </Link>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
              <button
                className="btn btn-light btn-sm rounded-circle p-1 shadow-sm border-0 d-flex align-items-center justify-content-center mt-1"
                style={{ width: "24px", height: "24px" }}
                data-bs-toggle="modal"
                data-bs-target="#addLabelModal"
                onClick={() => setSelectedCourseIds([row.original._id])}
              >
                <span
                  className="material-symbols-outlined text-primary"
                  style={{ fontSize: "16px" }}
                >
                  add
                </span>
              </button>
            </div>
          </div>
        ),
      },
      {
        accessorKey: "moderatorname",
        header: t("Owner"),
        size: 200,
        Cell: ({ row }) => (
          <div className="d-flex border-bottom-0">
            <div className="d-flex align-items-center gap-2">
              <div
                className="avatar rounded-circle overflow-hidden"
                style={{ width: "25px", height: "25px" }}
              >
                <img
                  src={
                    row.original.moderatorimage == ""
                      ? assetImages.defaultUser
                      : url.SERVER_URL + row.original.moderatorimage
                  }
                  alt="admin"
                  className="w-100 h-100 object-fit-cover object-center"
                />
              </div>
              <p>{row.original.moderatorname}</p>
            </div>
            <button
              onClick={() => {
                createContactChatHandler(
                  row.original.moderatorid,
                  "MOD_COURSE",
                  row.original._id,
                  row.original.title
                );
              }}
              className={
                row.original.moderatorid?.toString() === userInfo._id.toString()
                  ? "d-none"
                  : "d-flex align-items-center ms-auto border-0 bg-light"
              }
            >
              <span className="d-block material-symbols-outlined icon-md text-primary">
                chat
              </span>
            </button>
          </div>
        ),
      },
      //follower
      {
        accessorKey: "followersnames",
        header: t("Followers"),
        size: 250,
        Cell: ({ row }) =>
          row.original.followerslist.map((follower, index) => (
            <div
              className="owner border-bottom-0 d-flex gap-1 mb-1"
              key={index}
            >
              <img
                className="rounded-circle"
                height={15}
                width={15}
                src={
                  follower.image == ""
                    ? assetImages.defaultUser
                    : url.SERVER_URL + follower.image
                }
                alt="Babcock"
              />

              <p>
                <span className="d-block">{follower.fullname}</span>
              </p>
              <button
                onClick={() => {
                  createContactChatHandler(row.original._id);
                }}
                className={
                  follower._id === userInfo._id
                    ? "d-none"
                    : "d-flex align-items-center ms-auto border-0 bg-light"
                }
              >
                <span className="d-block material-symbols-outlined icon-md text-primary">
                  chat
                </span>
              </button>
            </div>
          )),
      },
      {
        accessorKey: "rank",
        header: t("Rank"),
        Cell: ({ row }) => (
          <div className="ranking border-bottom-0">
            {row.original.moderatorid.toString() === userInfo._id.toString() ||
            userInfo.role.slug === "ADMIN" ||
            userInfo.role.slug === "SUPER_ADMIN" ? (
              <input
                type="number"
                className="form-control fs-sm text-gray bg-white py-2 border-gray-300 shadow-none"
                style={{ width: "100px" }}
                value={row.original.rank}
                onChange={(e) => rankInputChangeHandler(row, e.target.value)}
              />
            ) : (
              <p className="ps-3">{row.original.rank}</p>
            )}
          </div>
        ),
      },
      {
        accessorKey: "code",
        header: t("Code"),
      },
      {
        accessorKey: "courselanguage",
        header: t("Language"),
      },
      {
        accessorKey: "chaptercount",
        header: t("Chapters"),
      },
      {
        accessorKey: "lessoncount",
        header: t("Lessons"),
      },
      {
        accessorKey: "membercount",
        header: t("Team"),
      },
      {
        accessorKey: "subscribercount",
        header: t("Subscribers"),
      },
      {
        accessorKey: "taskcount",
        header: t("Tasks"),
      },
      {
        accessorKey: "coursedate",
        header: t("Date"),
      },
      {
        accessorKey: "parentcourse",
        header: t("Parent Course"),
        size: 200,
      },
    ],
    [courseList, i18n.language, selectedCourseId, selectedTagId]
  );

  useEffect(() => {
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key]
    );

    if (selectedIdsArray.length > 0) {
      setSelectedCourseIds(selectedIdsArray);
    } else {
      setSelectedCourseIds([]);
    }
  }, [rowSelection]);

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    moduleAccess.includes("MOD_COURSE")
  ) {
    return (
      <div id="content_wrapper">
        <section className="survey-wrapper bg-white pb-5">
          <div className="container-fluid px-lg-5">
            {/* ---- header area ----*/}
            <CourseListHeader
              reloadList={resetFilter}
              bulkUpdateHandler={updateBulkCourseHandler}
              selectedCourseIds={selectedCourseIds}
              jsonFilterQuery={jsonFilterQuery}
            />

            {/* ---- table section ---- */}
            {isLoading ? (
              <div className="placeholder-glow d-flex flex-column gap-4">
                <span className="placeholder placeholder-lg bg-secondary col-12"></span>
                <span className="placeholder placeholder-lg bg-secondary col-8"></span>
                <span className="placeholder placeholder-lg bg-secondary col-4"></span>
              </div>
            ) : (
              <div className="table-wrapper">
                <MaterialReactTable
                  columns={columns} // map columns to be displayed with api data,
                  data={courseList} // data from api to be displayed
                  enableGrouping // to enable grouping of column
                  enableRowSelection // enable showing checkbox
                  getRowId={(row) => row._id} // map which value to select with row checkbox
                  onRowSelectionChange={setRowSelection} //connect internal row selection state to your own
                  state={{ rowSelection }} //pass our managed row selection state to the table to use
                  enableRowActions // show the action column
                  renderRowActionMenuItems={({ row }) => [
                    <MenuItem key="edit">
                      <Link
                        className="dropdown-item"
                        to={`/admin/course/save/${row.id}`}
                      >
                        {t("View Details")}
                      </Link>
                    </MenuItem>,
                    <MenuItem key="team">
                      <Link
                        className="dropdown-item"
                        to={`/admin/course/team/${row.id}`}
                      >
                        {t("View Members")}
                      </Link>
                    </MenuItem>,
                    <MenuItem key="chapter">
                      <Link
                        className="dropdown-item"
                        to={`/admin/course/chapter/list/${row.id}`}
                      >
                        {t("View Chapter")}
                      </Link>
                    </MenuItem>,
                    <MenuItem key="lesson">
                      <Link
                        className="dropdown-item"
                        to={`/admin/course/lessons/list/${row.id}`}
                      >
                        {t("View Lesson")}
                      </Link>
                    </MenuItem>,
                    <MenuItem key="subscriber">
                      <Link
                        className="dropdown-item"
                        to={`/admin/course/subscribers/${row.id}`}
                      >
                        {t("View Subscribers")}
                      </Link>
                    </MenuItem>,
                    <MenuItem key="task">
                      <Link
                        className="dropdown-item"
                        to={`/admin/course/task/list/${row.id}`}
                      >
                        {t("View Task Submitted")}
                      </Link>
                    </MenuItem>,
                    <MenuItem key="faq">
                      <Link
                        className="dropdown-item"
                        to={`/admin/course/faq/${row.id}`}
                      >
                        {t("View Faq")}
                      </Link>
                    </MenuItem>,
                    <MenuItem key="certification">
                      <Link
                        className="dropdown-item"
                        to={`/admin/course/certification/${row.id}`}
                      >
                        {t("View Certification")}
                      </Link>
                    </MenuItem>,
                  ]} // action columns menu items
                  defaultColumn={{
                    minSize: 20,
                    maxSize: 300,
                    size: 50, //make columns wider by default
                  }}
                  muiTableContainerProps={{
                    sx: {
                      maxHeight: "60vh",
                    },
                  }}
                  enableStickyHeader
                />
              </div>
            )}
          </div>
        </section>

        {/* ======== popups and modals area ======== */}
        {/* ------ add label modal-------- */}
        <AddLabelModal
          moduleName="course"
          afterTagModalClose={afterModalActionClose}
          selectedIds={selectedCourseIds}
          setAlertMessage={setAlertMessage}
          setMessageType={setMessageType}
          setShowAlert={setShowAlert}
          onModalClose={() => {
            setRowSelection({});
            setSelectedCourseIds([]);
          }}
        />

        {/* ------- filter popup ------- */}
        <CourseListFilterPopup
          setJsonFilterQuery={setJsonFilterQuery}
          reloadList={resetFilter}
          isFilterReset={isFilterReset}
          setIsFilterReset={setIsFilterReset}
          moduleSlug="courselist"
        />

        <AddFollowerModal
          moduleName="courselist"
          selectedIds={selectedCourseIds}
          afterModalClose={afterModalActionClose}
          setShowAlert={setShowAlert}
          setAlertMessage={setAlertMessage}
          setMessageType={setMessageType}
          onModalClose={() => {
            setRowSelection({});
            setSelectedCourseIds([]);
          }}
        />

        {/* ----------- delete warning modal ------------ */}
        <DeleteWarningModal
          onCancelDelete={() => {
            setRowSelection({});
            setSelectedCourseIds([]);
          }}
          onDelete={deleteMassiveCourseHandler}
          moduleName={t("course")}
        />

        {showAlert && (
          <AlertNotification
            showAlert={showAlert}
            message={alertMessage}
            alertType={messageType}
            onClose={onAlertClose}
          />
        )}
      </div>
    );
  } else {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          <div className="empty_access text-center">
            <div className="empty_pic mb-4">
              {" "}
              <img src={assetImages.emptyVector} alt="" />
            </div>
            <div className="empty_text">
              <p className="fs-lg text-gray fw-semibold mb-4">
                {t("Sorry....! You don't have privilege to see this content")}
              </p>
            </div>
          </div>
        </section>
      </div>
    );
  }
};

export default CourseListBody;
